export default __webpack_public_path__ + "static/media/esteban.a13ea067.jpg";